var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivationOptIns01 = function SvgActivationOptIns01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "activation_opt_ins-01_svg2__a",
    x1: 27.87,
    x2: 181.36,
    y1: 172.13,
    y2: 18.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#activation_opt_ins-01_svg2__a",
    id: "activation_opt_ins-01_svg2__b",
    x1: 54.53,
    x2: 208.02,
    y1: 198.8,
    y2: 45.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#activation_opt_ins-01_svg2__a",
    id: "activation_opt_ins-01_svg2__c",
    x1: 1.2,
    x2: 154.69,
    y1: 145.46,
    y2: -8.03
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M46.67 120c-18.38 0-33.33 14.95-33.33 33.33s14.95 33.33 33.33 33.33S80 171.71 80 153.33 65.05 120 46.67 120m0 60C31.97 180 20 168.04 20 153.33s11.96-26.67 26.67-26.67 26.67 11.96 26.67 26.67S61.38 180 46.67 180",
    style: {
      fill: "url(#activation_opt_ins-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.33 106.66H46.68C20.93 106.67 0 127.6 0 153.33S20.93 200 46.67 200h106.66c25.73 0 46.67-20.93 46.67-46.67s-20.93-46.67-46.67-46.67m0 86.67H46.67c-22.06 0-40-17.94-40-40s17.94-40 40-40h106.66c22.06 0 40 17.94 40 40s-17.94 40-40 40",
    style: {
      fill: "url(#activation_opt_ins-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.67 93.34h106.66c25.73 0 46.67-20.93 46.67-46.67S179.06 0 153.32 0H46.67C20.93 0 0 20.93 0 46.67s20.93 46.67 46.67 46.67m106.65-80.01c18.38 0 33.33 14.95 33.33 33.33s-14.95 33.33-33.33 33.33-33.33-14.95-33.33-33.33 14.95-33.33 33.33-33.33",
    style: {
      fill: "url(#activation_opt_ins-01_svg2__c)"
    }
  }));
};
export default SvgActivationOptIns01;